import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPinFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_924_104298)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.86667 7.06732V4.40065H10.4C10.6933 4.40065 10.9333 4.16065 10.9333 3.86732C10.9333 3.57398 10.6933 3.33398 10.4 3.33398H5.06667C4.77333 3.33398 4.53333 3.57398 4.53333 3.86732C4.53333 4.16065 4.77333 4.40065 5.06667 4.40065H5.6V7.06732C5.6 7.95265 4.88533 8.66732 4 8.66732V9.73398H7.184V13.4673L7.71733 14.0007L8.25067 13.4673V9.73398H11.4667V8.66732C10.5813 8.66732 9.86667 7.95265 9.86667 7.06732Z",
			fill: "#08786C"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_924_104298",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgPinFilled);
export { ForwardRef as ReactComponent };
